import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Link,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ModeToggle } from './ModeToggle';
import { useColorScheme } from '@mui/material/styles';

export const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isOnUploadPage = location.pathname.includes('upload');

  const { mode, systemMode } = useColorScheme();
  const currentMode = (mode === 'system' ? systemMode : mode) ?? 'light';
  const logoSrc = currentMode === 'dark' ? '/ce-dark.svg' : '/ce-light.svg';

  const base = process.env.PUBLIC_URL || '';
  const home = base + '/#/';
  const upload = base + '/#/upload';

  return (
    <AppBar position="static" color="default" sx={{ marginBottom: 4 }}>
      <Toolbar>
        <Link href={home} color="inherit" underline="none">
          <Box
            component="img"
            sx={{ verticalAlign: 'middle', paddingLeft: '5px', width: '159px', height: '40px' }}
            src={logoSrc}
            alt="Logo"
          />
        </Link>

        <Stack direction="row" gap={2} sx={{ marginLeft: 'auto' }}>
          <ModeToggle />
          <Button
            component={Link}
            href={isOnUploadPage ? home : upload}
            variant="contained"
            color="primary"
          >
            {isOnUploadPage ? t('header.buttonHome') : t('header.buttonUpload')}
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};